import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import { Link } from "@smb/ui-link";
import { useTranslation } from "react-i18next";

import { PRIVACY_TERMS_URL } from "../../environments/environment";

import { usePrivacyFooterStyles } from "./PrivacyFooter.styles";
import { PrivacyFooterProps } from "./PrivacyFooter.types";

// Results page for desktop and mobile devices
export const PrivacyFooter: React.FC<PrivacyFooterProps> = ({ disabled }) => {
  const privacyFooterStyles = usePrivacyFooterStyles();
  const { t } = useTranslation();

  return (
    <Flex column hAlign="center" vAlign="end" gap="gap.small">
      {!disabled ? (
        <Link
          aria-label={t("PRIVACY_COOKIES_LINK_A11Y_LABEL")}
          content={<>{t("PRIVACY_COOKIES")}</>}
          href={PRIVACY_TERMS_URL}
          textProps={{
            align: "center",
            size: "small",
            weight: "regular",
          }}
          linkProps={{ target: "_blank", rel: "noopener" }}
        />
      ) : (
        <Text
          content={<>{t("PRIVACY_COOKIES")}</>}
          aria-hidden="true"
          styles={privacyFooterStyles.privacyFooter}
          size="small"
          align="center"
          weight="regular"
        />
      )}
    </Flex>
  );
};
